import { Icon } from '@chakra-ui/react';

export const ArrowRightIcon = (props: any) => (
  <Icon aria-label="arrow right icon" {...props}>
    <path
      d="m8.41129061 6 1.58870939 1.48679212-3.755 3.51320788h15.755v2h-15.755l3.755 3.5132079-1.58870939 1.4867921-6.41129061-6z"
      transform="matrix(-1 0 0 1 24 0)"
      fill="currentColor"
    />
  </Icon>
);
